import React from 'react';
import { ISkin } from './ISkin';

/**
 * @not-collboard-modules-sdk
 */
export const SkinContext = React.createContext/* <- TODO: Import and use just a createContext */ <ISkin>(null as any);
